// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3QQbc","range":"MonthRangeSwitch_range__33Pyn","disabled":"MonthRangeSwitch_disabled__31Cor"};